"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccessibilityOptions = exports.getAccessibilityAttributes = void 0;
/**
 * To prepare accessibility attributes to apply on element.
 * @param {any} options component options
 */
function getAccessibilityAttributes(options) {
    var accessibilityAttrs = {};
    if (options) {
        if (typeof options.tabIndex !== 'undefined') {
            Object.assign(accessibilityAttrs, { tabIndex: options.tabIndex });
        }
        if (typeof options.arialabelledby !== 'undefined') {
            Object.assign(accessibilityAttrs, { 'aria-labelledby': options.arialabelledby });
        }
        if (typeof options.role !== 'undefined') {
            Object.assign(accessibilityAttrs, { role: options.role });
        }
    }
    return accessibilityAttrs;
}
exports.getAccessibilityAttributes = getAccessibilityAttributes;
/**
 * To abstract the accessibility options from component options.
 * @param {any} options component options
 */
function getAccessibilityOptions(options) {
    var accessibilityOptions = {};
    if (options) {
        if (typeof options.tabIndex !== 'undefined') {
            accessibilityOptions.tabIndex = options.tabIndex;
        }
        if (typeof options.arialabelledby !== 'undefined') {
            accessibilityOptions.arialabelledby = options.arialabelledby;
        }
        if (typeof options.role !== 'undefined') {
            accessibilityOptions.role = options.role;
        }
        if (typeof options.accessibility !== 'undefined') {
            accessibilityOptions.accessibility = options.accessibility;
        }
    }
    return accessibilityOptions;
}
exports.getAccessibilityOptions = getAccessibilityOptions;
//# sourceMappingURL=accessibility.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/utils/accessibility.js
// module id = 193
// module chunks = 8